import { render } from "./ScoreGQ6.vue?vue&type=template&id=7fb26d14&scoped=true"
import script from "./ScoreGQ6.vue?vue&type=script&lang=js"
export * from "./ScoreGQ6.vue?vue&type=script&lang=js"

import "./ScoreGQ6.vue?vue&type=style&index=0&id=7fb26d14&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fb26d14"]])

export default __exports__